import { render, staticRenderFns } from "./CollectionsHero.vue?vue&type=template&id=36ad2d49&scoped=true"
import script from "./CollectionsHero.vue?vue&type=script&lang=js"
export * from "./CollectionsHero.vue?vue&type=script&lang=js"
import style0 from "./CollectionsHero.vue?vue&type=style&index=0&id=36ad2d49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad2d49",
  null
  
)

export default component.exports